import { formatDate } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { LOCALIZATION_CONFIG, LocalizationConfig } from '@core/localization/localization.config';
import { StorageKeys } from '@core/storage/storage.keys';
import { LocalStorageService } from 'ngx-webstorage';

export const DATE_FORMAT_FULL = 'full';

/**
 * Date format storage service
 */
@Injectable()
export class DateFormatService {
    readonly #localStorage: LocalStorageService = inject(LocalStorageService);
    readonly #languageCodeFromStorage: string = this.#localStorage.retrieve(StorageKeys.Lang);
    readonly #localizationConfig: LocalizationConfig = inject(LOCALIZATION_CONFIG);

    /**
     * Get date format
     */
    public format(date: Date | string, format: 'date' | 'full' | 'my' = DATE_FORMAT_FULL): string {
        const item: {
            date: string;
            full: string;
            my: string;
        } =
            this.#localizationConfig.dateFormats[this.#languageCodeFromStorage] ||
            this.#localizationConfig.dateFormats[this.#localizationConfig.defaultLocale];

        return formatDate(date, item[format], this.#languageCodeFromStorage);
    }
}
